export default function customHoverItems() {
  const items = document.querySelectorAll(".mission-item");
  if (!items.length) return;

  const isDesktop = window.matchMedia("(min-width: 1024px)");

  function bind() {
    items.forEach(item => {
      item.onmouseenter = () => {
        items.forEach(i => i.classList.remove("active"));
        item.classList.add("active");
      };
    });
  }

  function unbind() {
    items.forEach(item => {
      item.onmouseenter = null;
    });
  }

  function init() {
    if (isDesktop.matches) {
      bind();
    } else {
      unbind();
    }
  }

  init();
  isDesktop.addEventListener("change", init);
}